





import Vue from 'vue'

export default Vue.extend({
  name: 'ProgressCircular',

  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }

})
